import type { Contact } from '@/types/contact';

export type NextTarget =
  | { kind: 'advance'; nextId: string; nextName: string }
  | { kind: 'end' }
  | { kind: 'more-unloaded' }
  | { kind: 'not-found' };

// ponytail: display-name fallback mirrors ContactsTableColumns.tsx:102-104;
// inlined rather than extracted to keep this diff to one file.
function displayName(contact: Contact): string {
  return contact.first_name || contact.last_name
    ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim()
    : contact.company_name || 'Unnamed Contact';
}

/**
 * Decides what "Next" does, from the currently-loaded contact list.
 * `contacts` is only the loaded pages; `totalCount` is the full filtered size,
 * so we can tell a genuine end-of-list from a not-yet-loaded edge.
 */
export function nextTarget(
  contacts: Contact[],
  totalCount: number,
  currentId: string | null,
): NextTarget {
  if (!currentId) return { kind: 'not-found' };
  const i = contacts.findIndex((c) => c.id === currentId);
  if (i === -1) return { kind: 'not-found' };
  if (i + 1 < contacts.length) {
    const next = contacts[i + 1];
    return { kind: 'advance', nextId: next.id, nextName: displayName(next) };
  }
  // current is the last loaded row
  return contacts.length >= totalCount ? { kind: 'end' } : { kind: 'more-unloaded' };
}
